import MenuOutlined from '@mui/icons-material/MenuOutlined';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { typedMemo } from '@utils';
import { useTranslation } from 'react-i18next';
import { BrzLogo } from './BrzLogo';
import { ProjectSelector } from './project-selector';
import { UserMenu } from './UserMenu';

interface AppBarProps {
  onMenuClick: () => void;
}

export const AppBar = typedMemo(({ onMenuClick }: Readonly<AppBarProps>) => {
  const { t } = useTranslation();

  return (
    <MuiAppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <IconButton
          size="medium"
          edge="start"
          color="inherit"
          sx={{ mr: 2.5 }}
          onClick={onMenuClick}
        >
          <MenuOutlined />
        </IconButton>
        <BrzLogo />
        <Typography
          className="BrzAppName"
          variant="overline"
          component="span"
          sx={{ flexGrow: 1 }}
        >
          {t('app.title')}
        </Typography>
        <ProjectSelector />
        <UserMenu />
      </Toolbar>
    </MuiAppBar>
  );
});
